import {
  useState, useEffect,
} from 'react';
import moment from 'moment';
import telemetryActions from '@state/telemetry/actions';
import constants from '@state/telemetry/constants';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const options = {
  colors: ['#05EB60', '#1221FF', '#00FFF0', '#05EB60', '#2CFF00', '#ec0adb'],
  stroke: {
    width: [2, 2, 2, 2, 2, 2],
    curve: 'smooth',
  },
  plotOptions: {
    bar: {
      columnWidth: '25%',
      // endingShape: 'rounded',
      horizontal: false,
    },
  },
  legend: {
    show: true,
    showForSingleSeries: true,
  },
  fill: {
    opacity: [0.85, 0.85, 1],
    gradient: {
      inverseColors: false,
      shade: 'light',
      type: 'vertical',
      opacityFrom: 0.85,
      opacityTo: 0.55,
      stops: [0, 100, 100, 100],
    },
  },
  markers: {
    size: 0,
  },
  yaxis: {
    show: true,
    showAlways: true,
    opposite: false,
    reversed: false,
    forceNiceScale: true,
    decimalsInFloat: 2,
    axisTicks: {
      show: true,
      borderType: 'solid',
      width: 10,
    },
    tooltip: {
      enabled: true,
      offsetX: -20,
    },
    axisBorder: {
      show: true,
      width: 1,
      height: '100%',
      offsetX: 0,
      offsetY: 0,
    },
    labels: {
      show: true,
      hideOverlappingLabels: false,
      trim: true,
      style: {
        fontSize: '12px',
        fontFamily: 'montserrat, sans-serif',
        fontWeight: 400,
        cssClass: 'apexcharts-xaxis-label',
      },
    },
  },
  dataLabels: {
    enabled: false,
    enabledOnSeries: [0, 1, 2, 3, 4, 5],
  },
};

function useBatterySoc() {

  const graphInitialData = useSelector(({ telemetry }) => telemetry.graphBatteryData);
  const loadingGraph = useSelector(({ telemetry }) => telemetry.loadingBatteryGraph);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [selectGraph, setSelectGraph] = useState(constants.BATTERY_CONSULT);
  const [attributeGraph, setAttributeGraph] = useState({
    graphData: [],
    dates: [],
    labels: [],
    typeGraph: 'area',
  });

  const handleSelectGraph = (e) => {

    setSelectGraph(e.target.value);
    if (e.target.value === constants.SOC_CONSULT) {

      dispatch(telemetryActions.setTypeConsultBattery(constants.SOC_CONSULT));

    } else {

      dispatch(telemetryActions.setTypeConsultBattery(constants.BATTERY_CONSULT));

    }

  };

  useEffect(() => {

    setAttributeGraph(graphInitialData);
    dispatch(telemetryActions.setLoadingGraphBattery(false));

  }, [graphInitialData]);

  useEffect(() => {

    setLoading(loadingGraph);

  }, [loadingGraph]);

  const {
    graphData,
    dates,
    labels,
    typeGraph,
    units,
  } = attributeGraph;

  let axisFormat;
  let category;
  let dateFormat;
  if (typeGraph === 'bar') {

    axisFormat = 'category';
    category = dates.map((date) => moment(date).format('YYYY-MM-DD'));
    dateFormat = 'YYYY-MM-DD';

  } else {

    category = dates;
    axisFormat = 'datetime';
    dateFormat = 'YYYY-MM-DD HH:mm';

  }
  const optionsGraph = {
    chart: {
      height: 400,
      type: typeGraph,
      stacked: false,
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
        },
        export: {
          csv: {
            filename: 'telemetry-data',
            columnDelimiter: ',',
          },
          svg: {
            filename: undefined,
          },
          png: {
            filename: undefined,
          },
        },
        autoSelected: 'selection',
      },
    },
    ...options,
    xaxis: {
      type: axisFormat,
      categories: category,
      labels: {
        rotate: -45,
        datetimeUTC: false,
        format: 'yyyy/dd/MM',
      },
    },
    yaxis: {
      title: {
        text: `${t('common.feedbacks.units_chart')} ( ${units} )`,
      },
      decimalsInFloat: 2,
      tickAmount: 10,
    },
    tooltip: {
      enabled: true,
      enabledOnSeries: [0, 1, 2, 3, 4, 5],
      shared: true,
      intersect: false,
      fixed: {
        enabled: false,
        position: 'topLeft',
        offsetY: -70,
      },
      followCursor: true,
      fillSeriesColor: false,
      theme: 'dark',
      style: {
        fontSize: '12px',
        fontFamily: undefined,
      },
      onDatasetHover: {
        highlightDataSeries: false,
      },
      x: {
        show: true,
        formatter(seriesName) {

          if (typeGraph === 'bar') {

            return moment(new Date(seriesName)).add(1, 'days').format(dateFormat);

          }

          return moment(new Date(seriesName)).format(dateFormat);

        },
      },
      y: {
        formatter(value) {

          if (typeof value !== 'undefined') {

            return value.toFixed(2);

          }
          return value;

        },
      },
      items: {
        display: 'flex',
      },
      marker: {
        show: true,
      },
    },
  };
  const series = labels.map((label, index) => {

    const dataSeries = {
      name: label,
      type: typeGraph,
      data: graphData[index],
    };
    return dataSeries;

  });

  return {
    loading,
    optionsGraph,
    series,
    typeGraph,
    selectGraph,
    handleSelectGraph,
    constants,
  };

}

export default useBatterySoc;
